import React, { Component } from 'react';

import '../css/lineas.css'

import linea1 from '../img/construccion-ico.svg'
import linea2 from '../img/morteros-ico.svg'
import linea3 from '../img/electrico-ico.svg'
import linea4 from '../img/plomeria-ico.svg'
import linea5 from '../img/herramientas-ico.svg'
import linea6 from '../img/techos-ico.svg'
import linea7 from '../img/pinturas-ico.svg'
import linea8 from '../img/perfileria-ico.svg'
import linea9 from '../img/hogar-ico.svg'

class Lineas extends Component {
  render() {
    return (
      <div className="container mt-4">
        <div className="lineastodo row no-gutters p-5">

          <div className="titulo col">Líneas de Productos</div>

          <div class="w-100"></div>

          <div className="linea col efectohover">
            <div><img className="lineas" src={linea1} alt=""/></div>
            <div className="lineastexto">Construcción</div>
          </div>
          <div className="linea col efectohover">
            <div><img className="lineas" src={linea2} alt=""/></div>
            <div className="lineastexto">Morteros</div>
          </div>
          <div className="linea col efectohover">
            <div><img className="lineas" src={linea3} alt=""/></div>
            <div className="lineastexto">Eléctrico</div>
          </div>
          <div className="linea col efectohover">
            <div><img className="lineas" src={linea4} alt=""/></div>
            <div className="lineastexto">Grifería y Plomería</div>
          </div>
          <div className="linea col efectohover">
            <div><img className="lineas" src={linea5} alt=""/></div>
            <div className="lineastexto">Herramientas</div>
          </div>

          <div class="w-100"></div>

          <div className="linea col efectohover">
            <div><img className="lineas" src={linea6} alt=""/></div>
            <div className="lineastexto">Techos</div>
          </div>
          <div className="linea col efectohover">
            <div><img className="lineas" src={linea7} alt=""/></div>
            <div className="lineastexto">Pinturas</div>
          </div>
          <div className="linea col efectohover">
            <div><img className="lineas" src={linea8} alt=""/></div>
            <div className="lineastexto">Perfilería</div>
          </div>
          <div className="linea col efectohover">
            <div><img className="lineas" src={linea9} alt=""/></div>
            <div className="lineastexto">Hogar</div>
          </div>
        </div>
      </div>
    )
  }
}

export default Lineas;
